import React, { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import { ErrorShower } from '../common-components/error-shower';
import { InputLabel } from '../common-components/input-label';
import { IChoiceInputProps } from '../input';
import {
	enrollmentContext,
	EnrollmentContextService,
} from '../../../context/enrollment/enrollment-context';
import { RadioButton } from '../../../../hoc/components/inputs';

const updateValue = (
	enrollmentCtxt: EnrollmentContextService,
	name: string,
	value: string | null
) => {
	const field = enrollmentCtxt.getFormField(name);
	if (field) {
		field.value = value;
	}
};

export interface IRadioGroup extends IChoiceInputProps {
	radioButtonClassName: string;
}

const RadioGroup = ({
	ariaLabel,
	label,
	required,
	errors,
	name,
	help,
	options,
	onChange,
	onFocus,
	className,
	disabled,
	value,
	register,
	radioButtonClassName,
}: IRadioGroup) => {
	const enrollmentCtxt = useContext(enrollmentContext);
	const [selectedAnswer, setSelectedAnswer] = useState<
		string | null | undefined
	>(value || undefined);
	useEffect(() => {
		if (disabled) {
			updateValue(enrollmentCtxt, name, null);
			setSelectedAnswer(null);
		}
	}, [disabled]);
	return (
		<>
			<InputLabel
				ariaLabel={ariaLabel}
				label={label}
				required={required}
				errors={errors}
				name={name}
				help={help}
			/>
			<div
				className={classNames(className, {
					'border-2 border-error': errors && errors[name as string],
				})}>
				{options?.map(option => {
					return (
						<RadioButton
							key={name + option.value}
							className={radioButtonClassName}
							id={name + option.value}
							label={option.key}
							name={name}
							ref={register({ required })}
							checked={selectedAnswer === option.value}
							onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
								updateValue(enrollmentCtxt, name, event.target.value);
								setSelectedAnswer(event.target.value);
								if (onChange) {
									onChange(event.target.value);
								}
							}}
							onFocus={(event: React.FocusEvent<HTMLInputElement>) => {
								if (onFocus) {
									onFocus(event);
								}
							}}
							value={option.value}
							disabled={disabled}
						/>
					);
				})}
			</div>
			{errors && errors[name as string] && (
				<div className="mt-2">
					<ErrorShower errors={errors} name={name} />
				</div>
			)}
		</>
	);
};

export default RadioGroup;
